import { useCallback } from 'react'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { isHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { useMutationDownloadMasterCsv } from '../api/useMutationDownloadMasterCsv'

const getDownloadErrorMessage = (error: unknown): string => {
  if (isHTTPError(error)) {
    if (error.status === 409) {
      return '一括処理中は登録済みマスタデータをダウンロードできません。完了後にもう一度お試しください'
    }
  }
  return '登録済みマスタデータのダウンロードに失敗しました。'
}

export const useDownloadMasterCsv = (
  masterUuid: string,
  masterName: string,
) => {
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar()

  const downloadMutation = useMutationDownloadMasterCsv({
    onError: error => {
      showErrorSnackbar(getDownloadErrorMessage(error))
    },
    onSuccess: () => {
      showSuccessSnackbar('登録済みマスタデータのダウンロードが完了しました')
    },
  })

  const downloadMasterCsv = useCallback(() => {
    downloadMutation.mutate({ masterUuid, masterName })
  }, [downloadMutation, masterUuid, masterName])

  return {
    downloadMasterCsv,
    isDownloading: downloadMutation.isPending,
  }
}
